import React from 'react';

export default function ValidationCell(props) {
  // Validation cells are only working on aggregate level
  if (props.node && !props.node.group) return '';

  // Select all for filter options or blank for cell
  if (typeof props.value != "boolean" && props.value) return props.value;

  // No validation error
  if (props.value) return <i className='fa fa-check text-primary'/>  
  // Validation error
  return <i className='fa fa-times text-danger'/>
};